/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect } from 'react'
import { Layout } from 'antd'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import AdvCasinoBannerButton from '@components/Button/AdvCasinoBannerButton'
//img
import GuideSiderBtnImg from '@assets/images/btn/guide-sider-btn.png'
import UsageGuideVideoButtonImg from '@assets/images/btn/usage-guide-video-button.png'

import { Modal } from 'antd-mobile'
import { ModalBg, SafeAreaConstantPadding, SafeAreaEnvPadding } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { Button, CloseBtn } from '@styles/button.style'
import styled from '@themes/theme'
import Login from '@views/Login'
import { GlobalStoreKey } from '@v2/constants/common'
import { GuideSiderBtnStlye, SiderStyle, UsageGuideVideoSiderBtnStyle } from './index.style'
import UserSiderMenu from './UserSiderMenu'
import SiderMenu from './Menu'
import StorageUtils from '@utils/storage-utils'
import PopupUtils from '@utils/popup-utils'

const VersionWrap = styled.div`
  //position: absolute;
  //bottom: 4px;
  //left: 30px;
    //padding-bottom: ${SafeAreaEnvPadding};
    // padding-bottom: ${SafeAreaConstantPadding};
  margin-left: 12px;
  padding-bottom: 4px;
  color: ${props => props.theme.color.disableTxt};
  font-size: 1rem;
`
const Sider: React.FC = () => {
  const { globalStore, authStore, componentStore, logStore } = useRootStore()
  const { visibleSideBar, sideBarTheme } = globalStore
  const { isSignedIn } = authStore

  useEffect(() => {
    initGiftBoxNoticeTextImageHide()

    if (visibleSideBar) {
      if (!isSignedIn) {
        globalStore.addAppScrollHiddenClass()
      } else {
        globalStore.removeAppScrollHiddenClass()
      }
    } else {
      globalStore.removeAppScrollHiddenClass()
    }

  }, [visibleSideBar, isSignedIn])

  const initGiftBoxNoticeTextImageHide = () => {
    if (!isMobile || !isSignedIn || !visibleSideBar) {
      return
    }

    const isHide = StorageUtils.isGiftBoxNoticeTextImageHideOnMobileMenu()
    if (!isHide) {
      StorageUtils.saveGiftBoxNoticeTextImageHideOnMobileMenu()
    }
  }

  const onClose = () => {
    if (isSignedIn) {
      logStore.writeButtonLog({ pageId: 'd010', buttonId: '002' }).catch(console.error)
    }
    globalStore.setVisibleSideBar(false)
  }

  const onClickTutorialVideoPopup = () => {
    logStore.writeButtonLog({ pageId: 'd010', buttonId: '017' }).catch(console.error)
    globalStore.setVisibleSideBar(false)
    globalStore.setVisibleTutorialVideoPopup(true)
  }

  const isVisibleTutorialVideoPopup = () => {
    return globalStore.findGlobalSetting(GlobalStoreKey.TUTORIAL_VIDEO_POPUP_BUTTON_DISPLAY_ENABLED)?.value === '1' ?? false
  }

  const onClickUsageGuideVideoPopup = () => {
    globalStore.setVisibleSideBar(false)
    PopupUtils.showUsageGuideVideo({ entry: 'manual' })
  }

  const isVisibleUsageGuideVideoButton = () => {
    const { enabled, videoFileName } = globalStore.getUsageGuideVideoPopupOptions()
    return enabled && !!videoFileName
  }

  let contentElem: React.ReactElement
  if (isSignedIn) {
    contentElem = (
      <Fragment>
        <Layout.Sider
          key="Sider:LayoutSider"
          width="100%"
          trigger={null}
          theme={sideBarTheme}
          collapsible={false}
          collapsed={false}
          css={SiderStyle}
        >
          <div className="top">
            <UserSiderMenu key="Sider:UserSiderMenu"/>
            <SiderMenu key="Sider:SiderMenu"/>
          </div>
          <div className="bottom">
            {/* 메뉴의 초보자 가이드 영상 버튼 */}
            {isVisibleTutorialVideoPopup() &&
              <Button TP css={GuideSiderBtnStlye} onClick={onClickTutorialVideoPopup}>
                <img src={GuideSiderBtnImg} alt="메뉴의 초보자 가이드 영상 버튼"/>
              </Button>
            }
            {/* 메뉴의 이용방법 영상 수동 진입 버튼 */}
            {isVisibleUsageGuideVideoButton() &&
              <Button TP css={UsageGuideVideoSiderBtnStyle} onClick={onClickUsageGuideVideoPopup}>
                <img src={UsageGuideVideoButtonImg} alt="승부사 이용방법"/>
              </Button>
            }
            <VersionWrap>{componentStore.getAppVersion()}</VersionWrap>
            {isMobile &&
              <Fragment>
                <Button TP onClick={onClose} className="full-modal-cls-btn sider">
                  <span className="close-txt">닫기</span>
                  <div className="btn-bg">
                    <span className="cls-ico"/>
                  </div>
                </Button>
              </Fragment>
            }
          </div>
        </Layout.Sider>
        <AdvCasinoBannerButton className="sider-banner"/>
      </Fragment>
    )
  } else {
    contentElem = <Fragment>
      <Login/>
      <Button onClick={onClose} className="login-close-btn close-btn" css={CloseBtn}>
        <span className="close-txt">닫기</span>
      </Button>
    </Fragment>
  }

  return (
    <Modal
      popup
      maskClosable={false}
      visible={visibleSideBar}
      animated={false}
      animationType="slide-up"
      wrapClassName="sider-modal"
      className="full-modal sider"
      onClose={onClose}
    >
      {/*<MenuWrap className={sideBarCollapsed ? 'adv-hidden' : 'sider'}>*/}
      {/*  <Drawer*/}
      {/*    mask={!isMobile}*/}
      {/*    key="Sider:Drawer"*/}
      {/*    css={DrawerWrap}*/}
      {/*    visible={!sideBarCollapsed}*/}
      {/*    placement="left"*/}
      {/*    onClose={onClose}*/}
      {/*    maskClosable={isMobile}*/}
      {/*    // closable={!isSignedIn}*/}
      {/*    closable={false}*/}
      {/*    className="sider"*/}
      {/*  >*/}

      {contentElem}

      {!isMobile && <ModalBg className="sider-mask"/>}
      {/*</Drawer>*/}
      {/*</MenuWrap>*/}
    </Modal>
  )
}

export default observer(Sider)
